import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ClockCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/ClockCircleTwoTone";
import AntdIcon from "../components/AntdIcon";
var ClockCircleTwoTone = function ClockCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ClockCircleTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ClockCircleTwoTone.displayName = 'ClockCircleTwoTone';
}
export default /*#__PURE__*/React.forwardRef(ClockCircleTwoTone);